import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';

import {WhatWeDoRoutingModule} from './what-we-do-routing.module';
import {WhatWeDoComponent} from './what-we-do.component';
import {ProgramsComponent} from './programs/programs.component';
import {MissionsComponent} from './missions/missions.component';
import {ServicesComponent} from './services/services.component';
import {SundaySchoolComponent} from './sunday-school/sunday-school.component';
import {YouthComponent} from './youth/youth.component';
import {MarriageComponent} from './marriage/marriage.component';
import {HomegroupsComponent} from './homegroups/homegroups.component';
import {CampsComponent} from './camps/camps.component';
import {PuppetComponent} from './puppet/puppet.component';
import {PantomimeComponent} from './pantomime/pantomime.component';
import {PlantedChurchesComponent} from './planted-churches/planted-churches.component';
import {MissionariesComponent} from './missionaries/missionaries.component';
import {BibleschoolComponent} from './bibleschool/bibleschool.component';

@NgModule({
    imports: [
        SharedModule,
        WhatWeDoRoutingModule
    ],
    declarations: [
        WhatWeDoComponent,
        ProgramsComponent,
        MissionsComponent,
        ServicesComponent,
        SundaySchoolComponent,
        YouthComponent,
        MarriageComponent,
        HomegroupsComponent,
        CampsComponent,
        PuppetComponent,
        PantomimeComponent,
        PlantedChurchesComponent,
        MissionariesComponent,
        BibleschoolComponent
    ]
})
export class WhatWeDoModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/what-we-do.module.ts